// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Transition
 */
export interface Transition {
  /**
   * RFC3339 timestamp for the transition event.
   * @type {Date}
   * @memberof Transition
   */
  timestamp: Date;
  /**
   * Whether the billing account is funded at this transition.
   * @type {boolean}
   * @memberof Transition
   */
  isFunded: boolean;
  /**
   * Reason for being unfunded (empty when funded).
   * @type {string}
   * @memberof Transition
   */
  unfundedReason: string;
}

/**
 * Check if a given object implements the Transition interface.
 */
export function instanceOfTransition(value: object): value is Transition {
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('isFunded' in value) || value['isFunded'] === undefined) return false;
  if (!('unfundedReason' in value) || value['unfundedReason'] === undefined)
    return false;
  return true;
}

export function TransitionFromJSON(json: any): Transition {
  return TransitionFromJSONTyped(json, false);
}

export function TransitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Transition {
  if (json == null) {
    return json;
  }
  return {
    timestamp: new Date(json['timestamp']),
    isFunded: json['isFunded'],
    unfundedReason: json['unfundedReason'],
  };
}

export function TransitionToJSON(json: any): Transition {
  return TransitionToJSONTyped(json, false);
}

export function TransitionToJSONTyped(
  value?: Transition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    timestamp: value['timestamp'].toISOString(),
    isFunded: value['isFunded'],
    unfundedReason: value['unfundedReason'],
  };
}
